<template>
  <span class="cardpictos">
    <SfImage alt="CB" class="picto" height="32" placeholder="/assets/images/magicPlaceholder.gif"
             src='/assets/images/cards/cb.svg' width="0"></SfImage>
     <SfImage alt="amex" class="picto" height="32" placeholder="/assets/images/magicPlaceholder.gif"
              src='/assets/images/cards/amex.svg'
              width="0"></SfImage>
     <SfImage alt="mastercard" class="picto" height="32" placeholder="/assets/images/magicPlaceholder.gif"
              src='/assets/images/cards/mastercard.svg'
              width="0"></SfImage>
     <SfImage alt="visa" class="picto" height="32" placeholder="/assets/images/magicPlaceholder.gif"
              src='/assets/images/cards/visa.svg'
              width="0"></SfImage>
  </span>

</template>

<script>
import {
  SfImage,
} from '@storefront-ui/vue';


export default {
  name: 'CardPictos',

  components: {
    SfImage,

  },
};
</script>

<style lang="scss" scoped>
.cardpictos {
  display: flex;
  align-items: center;
  margin-left: auto;

  .picto {

    margin: var(--spacer-xs);

    ::v-deep {
      .sf-image {
        width: auto;
      }
    }

    &:first-of-type {
      margin-left: 0;
    }
  }
}
</style>
